import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import BlockConfirmation from '../../components/block-confirmation';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const BlockMemberModal = ({ closeModal, blockMember, t }) =>
  <Modal onClose={closeModal}>
    <BlockConfirmation
      title={t('block-member-modal.block-user')}
      message={t('block-member-modal.are-you-sure')}
      confirmButton={t('block-member-modal.confirm')}
      onConfirm={blockMember}
      onCancel={closeModal}
    />
  </Modal>;

BlockMemberModal.propTypes = {
  userId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  blockMember: PropTypes.func.isRequired,
  t: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      blockMember: () => closeModal(ownProps.userId),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(BlockMemberModal));



// WEBPACK FOOTER //
// ./app/containers/block-member-modal/block-member-modal.js